import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { IKeyValuePair } from 'src/modules/shared/interfaces/IKeyValuePair';
import { IOptionSetConfig } from 'src/modules/shared/interfaces/IOptionSetConfig';
import { IAircraftOwner } from 'src/modules/shared/interfaces/IAircraftOwner';
import { copyObject } from 'src/modules/shared/utils/utility';
import {IGuidItem} from "../../../shared/interfaces/IGuidItem";

@Component({
  selector: 'app-aircraft-owner-details',
  templateUrl: './aircraft-owners-details.component.html',
  styleUrls: ['./aircraft-owners-details.component.css'],
})
export class AircraftOwnersDetailsComponent implements OnInit {
  private INITIAL_STATE: IAircraftOwner = {
    OwnerAddress: '',
    OwnerFullName: '',
  };
  isNoRequests = false;
  @Input() Requests: IAircraftOwner[] = [];
  @Input() readonly: boolean = false;
  @Input() aircraftProfileId: IGuidItem;
  @Input() aircraftRegistrationRequestId: IGuidItem;
  @Input() showError: boolean;
  @ViewChild('AddForm') addFormModel: NgForm;

  invalid: boolean = false;
  systemOptions: IKeyValuePair[];

  systemConfig: IOptionSetConfig = {
    displayKey: 'Key',
    search: false,
    placeholder: 'Please Select System',
    noResultsFound: '',
    searchPlaceholder: '',
  };
  isEditMode = false;
  isAddingNewSystem = false;
  currentEditIndex = -1;
  currentRequests: IAircraftOwner = this.getInitialState();

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {}

  handleAddingNewRecordClick() {
    this.isAddingNewSystem = true;
  }

  checkRequests() {
    if (this.Requests.length < 1) {
      this.isNoRequests = true;
    } else {
      this.isNoRequests = false;
    }
  }
  onDelete(index: number) {
    if (this.Requests.length != 1) this.Requests.splice(index, 1);
    else if (this.Requests.length == 1 && index == 0) this.Requests.shift();
    this.resetComponent();
    this.checkRequests();
  }

  onEdit(index: number) {
    this.currentRequests = copyObject(this.Requests[index]);
    this.currentEditIndex = index;
    this.isAddingNewSystem = true;
    this.isEditMode = true;
  }

  onSave() {
    if (this.addFormModel.invalid) {
      this.invalid = true;
      return null;
    }
    if (this.isEditMode) {
      this.Requests[this.currentEditIndex] = this.currentRequests;
    } else {
      this.Requests.push(this.currentRequests);
    }
    this.resetComponent();
    this.checkRequests();
  }

  onCancel() {
    this.resetComponent();
  }

  private resetComponent() {
    this.currentRequests = this.getInitialState();
    this.isAddingNewSystem = false;
    this.isEditMode = false;
    this.currentEditIndex = -1;
  }

  private setSystemOptions() {
    this.activatedRoute.data.subscribe(data => {
      this.systemOptions =
        data.SystemOptions !== null && data.SystemOptions.Result && data.SystemOptions.Result.Values
          ? data.SystemOptions.Result.Values
          : [];
    });
  }

  getInitialState() {
    let initialState =  copyObject(this.INITIAL_STATE);
    this.attachAircraftRegistrationMarkAndRequest(initialState);
    return initialState;
  }

  attachAircraftRegistrationMarkAndRequest(initialState: IAircraftOwner) {
   if (this.aircraftProfileId)
     initialState.AircraftRegistrationMark = this.aircraftProfileId;
    if (this.aircraftRegistrationRequestId )
      initialState.AircraftRegistrationServiceRequest = this.aircraftRegistrationRequestId;
  }
}
